export const INITIALIZE_CONFIG = 'INITIALIZE_CONFIG';

// Choose org actions
export const DISPLAY_ORGANIZATIONS = 'DISPLAY_ORGANIZATIONS';
export const LOADING_ORGANIZATIONS = 'LOADING_ORGANIZATIONS';
export const ORGANIZATION_ERROR = 'ORGANIZATION_ERROR';
export const NO_ORGANIZATIONS = 'NO_ORGANIZATIONS';
export const SUBMIT_CHOOSE_ORG_SUCCESS = 'SUBMIT_CHOOSE_ORG_SUCCESS';
export const SUBMIT_CHOOSE_ORG_FAILURE = 'SUBMIT_CHOOSE_ORG_FAILURE';
